import { AddVendorRequest } from './add.vendor.request';

export class EditVendorRequest extends AddVendorRequest {
    ID: number;
}
